<div>
  <form [formGroup]="form">
    <div formArrayName="pairs">
      @for (group of formArray.controls; track group; let i = $index) {
        <div [formGroupName]="i"
             class="row g-2 mb-2 align-items-center">
          <div class="col-md-4">
            <input type="text"
                   formControlName="key"
                   class="form-control"
                   placeholder="Key" />
          </div>

          <div class="col-md-5">
            <input [type]="getValueInputType(i)"
                   class="form-control"
                   formControlName="value"
                   [placeholder]="getValuePlaceholder(i)" />
          </div>

          <div class="col-md-2">
            <div class="form-check form-switch pt-2">
              <input class="form-check-input"
                     type="checkbox"
                     formControlName="isSecret"
                     [id]="'key-value-secret-toggle-' + i" />
              <label class="form-check-label"
                     [for]="'key-value-secret-toggle-' + i">Secret</label>
            </div>
          </div>

          <div class="col-auto">
            <button type="button"
                    class="btn btn-outline-primary border-0 btn-sm text-danger"
                    [hidden]="!allowEditing()"
                    (click)="removePair(i)">
              <fa-icon icon="trash"></fa-icon>
            </button>
          </div>
        </div>
      }
    </div>
  </form>
  <div class="d-flex">
    @if (allowEditing()) {
      <button type="button"
              class="btn btn-primary mb-3"
              (click)="addPair()">Add row</button>

      <button type="button"
              class="btn btn-primary mb-3 ms-auto"
              data-testid="app-settings-save-button"
              (click)="submit()">Save</button>
    }
  </div>
</div>